// extracted by mini-css-extract-plugin
export var orderDetails = "_q9-2";
export var orderImage = "_q9-1";
export var orderMeta = "_q9-3";
export var orderSummary = "_q9-0";
export var rightArrow = "_q9-4";